import gql from 'graphql-tag';

import googleDriveSharedDriveFragment from './googleDriveSharedDriveFragment';

export const googleDriveSharedDrivesPageFragment = gql`
  fragment googleDriveSharedDrivesPageFragment on GoogleDriveSharedDrivesPage {
    dokkioClass
    nextPageToken
    sharedDrives {
      ...googleDriveSharedDriveFragment
    }
  }
  ${googleDriveSharedDriveFragment}
`;
export default googleDriveSharedDrivesPageFragment;
